import React, { useCallback } from 'react';
import { isStudyflixMindItem } from '../../../utils/typeGuards';
import { StudyflixMindItem, VideoMindItem } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import VideoPlayerVimeo from '../../Reader/ReaderContent/ReaderVideoContent/ReaderVideoContentVimeo/VideoPlayerVimeo';
import { 
  StudyflixError, 
  VideoPlayerStudyflix 
} from '../../Reader/ReaderContent/ReaderVideoContent/ReaderVideoContentStudyflix';
import { selectUser } from '../../../reducers/user.selectors';
import { useSelector } from 'react-redux';
import { ReaderContentViewVariant } from '../../../types/reader';

interface ReaderVideoPlayerProps {
  mindItem: StudyflixMindItem | VideoMindItem;
  isPublicVideoPlayer: boolean;  // if true, the video can be watched without authentication
  variant: ReaderContentViewVariant;
}

const ReaderVideoPlayer = ({ mindItem, isPublicVideoPlayer, variant }: ReaderVideoPlayerProps) => {
  const user = useSelector(selectUser);

  // TODO: Implement these callbacks
  const handleSetIsReady = useCallback(() => {}, []);
  const handleOnPause = useCallback(() => {}, []);

  if (isStudyflixMindItem(mindItem)) {
    const hasUserAccess = user?.hasDocumentLevelAccess || isPublicVideoPlayer;
    if (!mindItem.studyflixVideo.id) return <StudyflixError thumbnail={mindItem.thumbnail} />;
    if (hasUserAccess) {
      return <VideoPlayerStudyflix studyflixId={mindItem.studyflixVideo.id} />;
    } else {
      return <StudyflixError thumbnail={mindItem.thumbnail} />;
    }
  } else {
    return (
      <VideoPlayerVimeo
        mindItemId={mindItem.id}
        classYears={mindItem.classYears}
        title={mindItem.title}
        schoolTypes={mindItem.schoolTypes}
        subjects={mindItem.subjects}
        publisher={mindItem.publisher}
        variant={variant}
        url={mindItem.video.link}
        setIsReady={handleSetIsReady}
        onPause={handleOnPause}
        isPublic={isPublicVideoPlayer}
      />
    );
  }
};

export default ReaderVideoPlayer;
